<template>
    <base-card>
        <h3>Página no encontrada</h3>
        <p>La página que buscas no existe.</p>
        <base-button @click="leave">Volver a la página principal</base-button>
    </base-card>
</template>

<script>
export default {
    methods: {
        leave() {
            this.$router.replace('/inicio');
        }
    }
}
</script>

<style scoped>
button {
    display: block;
    margin: 0 auto;
}
</style>